import { Car } from "../app/(general-header)/prizes/cars/macros/ourCars/types";

export const getCarProps = (prize: Car) => {
  return {
    make: prize.SwitchMakeAndModel ? prize.Model : prize.Make,
    model: `${prize.SwitchMakeAndModel ? prize.Make : prize.Model} ${prize.AdditionalCashText?.length > 0 ? prize.AdditionalCashText : ""}`,
    cashText:
      prize.HasCashAlternative && !prize.HideCashAlternative && !prize.Model.toLowerCase().includes("cash")
        ? prize.CashAlternative
        : null,
    logoImageSource: prize.IsFeatured && prize.ManufacturerLogoImage,
    saleTicketPrice: prize.SaleTicket?.FormattedPrice,
    baseTicketPrice: prize.BaseTicket.FormattedPrice,
    carImageSource: prize.ThumbnailImage ?? "/assets/images/prize-error.png",
    currencySymbol: prize.ActiveTicket.CurrencySymbol,
    saleTicketPriceWithoutCurrency: prize.SaleTicket?.FormattedPrice.replace(prize.SaleTicket.CurrencySymbol, ""),
    baseTicketPriceWithoutCurrency: prize.BaseTicket.FormattedPrice.replace(prize.BaseTicket.CurrencySymbol, ""),
    discountPercentage: getCarPercentageDiscounted(prize),
    overrideDiscount: prize.OverrideDiscountValue,
    maxTicketsPerUser: prize.MaxTicketsPerUser,
    competitionId: prize.CompetitionId,
    prizeId: prize.ContentNodeId,
    hideCashAlternative: prize.HideCashAlternative,
  };
};

export const getCarPercentageDiscounted = (prize: Car) => {
  const cp = Number(prize.BaseTicket.FormattedPrice.replace(prize.BaseTicket.CurrencySymbol, ""));
  const sp = Number(prize.SaleTicket?.FormattedPrice.replace(prize.SaleTicket?.CurrencySymbol, ""));
  if (sp && cp > sp) {
    const discountPercent = ((cp - sp) * 100) / cp;
    return Math.round(discountPercent);
  }
  return 0;
};
